export default {
  SET_PROMO_RATE_PLANS (state, promo_rate_plans) {
    state.promo_rate_plans = promo_rate_plans
  },
  REMOVE_RECORD (state, itemId) {
    const promoRatePlanIndex = state.promo_rate_plans.findIndex((u) => u.id === itemId)
    state.promo_rate_plans.splice(promoRatePlanIndex, 1)
  }
}
